<template>
  <!-- 热门互动 -->
  <div class="hotConfig">
    <h4 class="describe">热门互动</h4>
    <div class="hotWrap">
      <h6 class="tips">活动配置</h6>
      <div class="show">
        <span>说明：</span>
        <span
          >1、在积分任务和积分乐园活动列表中未开始和进行中的活动均会在列表展示，可通过显示/隐藏控制在C端的显示；</span
        >
        <span
          >2、该模块最多显示4个活动，当超过4个时，取顶部4个活动进行展示；不足4个时，按实际活动数量展示；</span
        >
        <span
          >(2)、图标，根据活动类型来显示不一样的图标</span
        >
        <span
          >(3)、所有的活动首次默认是隐藏状态，需手动显示</span
        >
      </div>

      <!-- 配置表格 -->
      <configTable
        :configHead="configHead"
        :configList="pageConfig.menberPage.hotList"
      ></configTable>
    </div>
    <!-- 图片库 -->
    <PhotoGallery
      :isShow="photoGalleryVisible"
      @close="photoGalleryChange"
    ></PhotoGallery>
    <!-- 链接管理 -->
    <LInkAdmin :isShow="linkAdminVisible" @close="linkAdminChange"></LInkAdmin>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import configTable from "../configTable";
import PhotoGallery from "@/components/PhotoGallery";
import LInkAdmin from "@/components/LInkAdmin";
import selectPictureMiXin from "@/mixin/selectPictureMiXin";
export default {
  components: {
    configTable,
    PhotoGallery,
    LInkAdmin,
  },
  computed: {
    ...mapState(["pageConfig"]),
  },
  mixins: [selectPictureMiXin],
  data() {
    return {
      isShow: true,
      configHead: [
        { name: "活动名称", flex: 2 },
        { name: "状态", flex: 2 },
        { name: "图标", flex: 1 },
        { name: "排序", flex: 1 },
        { name: "操作", flex: 1 },
      ],
      navSelect: 0,
      checkbox: false,
      photoGalleryVisible: false,
      linkAdminVisible: false,
      curSelectItem: null,
    };
  },
  methods: {
    ...mapMutations([
      "movePower",
      "addPowerItem",
      "replaceIcon",
      "deletePower",
      "checkCurLinkItem",
      "editItemLink",
      "switchPowerItem",
    ]),
    // 选择链接后返回
    linkAdminChange(data) {
      this.linkAdminVisible = false;
      if (data) {
        //有数据返回
        this.editItemLink(data);
      }
    },
  },
};
</script>
<style lang="scss">
.hotConfig {
  .configTable {
    height: 500px;
  }
}
</style>
<style lang="scss" scoped>
.hotConfig {
  .configTable {
    height: 480px;
  }
  .describe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 28px;
    margin: 0;
    text-align: left;
    height: 64px;
    background-color: #f5f5f5;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    .desc {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .hotWrap {
    box-sizing: border-box;
    padding: 20px 28px;
    text-align: left;
    border-bottom: 1px solid #f3f3f3;
    .tips {
      position: relative;
      display: inline-block;
      color: #333;
      font-size: 14px;
      font-weight: 500;
      &::after {
        content: "*";
        position: absolute;
        right: -8px;
        top: 2px;
        color: #ff3a27;
      }
    }
    .show {
      display: flex;
      flex-direction: column;
      margin-top: 14px;
      color: #333;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      span {
        &:first-child {
          margin-bottom: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
.configTable {
  margin-top: 20px;
  max-height: 660px;
  overflow: scroll;
  &.centerMove-enter-active {
    transition: all 1s;
    &::-webkit-scrollbar-thumb {
      background: #ddd;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-track {
    background: rgba(246, 246, 246, 1);
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: #f5f7fa;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }
  .configTh {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 30px;
    height: 50px;
    background-color: #fafafa;
    span {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .configItem {
    box-sizing: border-box;
    padding: 16px 30px 20px;
    border-bottom: 1px solid #f3f3f3;
    .edit {
      display: flex;
      align-items: center;
      .ipt {
        flex: 3;
        height: 32px;
        /deep/ .el-input__inner {
          width: 90%;
          height: 32px;
        }
      }
      .icons {
        flex: 1;
        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
      .sort {
        flex: 1;
        i {
          cursor: pointer;
          &.disabled {
            color: #dddddd;
            cursor: no-drop;
          }
        }
      }
      .delete {
        flex: 1;
        cursor: pointer;
        color: #7f85e9;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .link {
      position: relative;
      margin-top: 16px;
      .jumpLink {
        position: absolute;
        right: 1px;
        top: 1px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #eeeeee;
        cursor: pointer;
      }
      .linkIpt {
        height: 32px;
        /deep/ .el-input__inner {
          height: 32px;
        }
      }
    }
  }
  .handle {
    box-sizing: border-box;
    padding-left: 30px;
    margin-top: 16px;
    color: #999;
    font-size: 13px;
    font-weight: 400;
    .add {
      display: inline-block;
      margin-right: 12px;
      cursor: pointer;
      color: #7f85e9;
    }
  }
}
</style>
